
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.34 2.935l-1.41 1.41 4.36 4.36-.29.3H3v6h4l5 5v-6.59l4.18 4.18c-.65.49-1.38.88-2.18 1.11v2.06a8.94 8.94 0 003.61-1.75l2.05 2.05 1.41-1.41L4.34 2.935zM10 15.175l-2.17-2.17H5v-2h2.83l.88-.88 1.29 1.29v3.76zm8.59-.83c.26-.73.41-1.52.41-2.34 0-3.17-2.11-5.85-5-6.71v-2.06c4.01.91 7 4.49 7 8.77 0 1.39-.32 2.7-.88 3.87l-1.53-1.53zM12 4.005l-1.88 1.88L12 7.765v-3.76zm2 3.97a4.5 4.5 0 012.5 4.03c0 .08-.01.16-.02.24L14 9.765v-1.79z","fill":"#fff"}})])
          )
        }
      }
    